<script>
	import Layout from "../layouts/main.vue";
	import GridBox from '../components/grid-boxes/GridBox.vue';
	import GridTable from '../components/tables/GridTable.vue';

  	export default {
    	components: { Layout, GridBox, GridTable },    

		props: {
			get_event: Array,
			unread_events: Number,
			unread_news: Number,
			all_locked_users: Array,
			tasks: Array,
			all_campaigns: Array,
			get_all_own_generated_invoice: Array,
			sb_count: Number,
			tc_count: Number,
			tp_count: Number,
			prospect_sb: Number,
			prospect_tc: Number,
			prospect_tp: Number,
			active_sb: Number,
			active_tc: Number,
			active_tp: Number,
			encryptedUserId: String,
			onlyContactsUrlEncrpt: String,
			prospectUrlEncrpt: String,
			activeUrlEncrpt: String,
		},
		data() {
			return {
				title: this.$page.props.auth.user.user_type_text + " - Dashboard",
			};
		},
		computed: {
			isNeedResubscribe() {
				return this.$page.props.auth.user.isNeedResubscribe;
			},
			currentMonthCalEvents() {
				return this.$page.props.auth.user.get_events_this_month
			},
			newNotifications() {
				return this.$page.props.auth.user.get_new_notifications
			},
			contactsCount() {
				if(this.$page.props.auth.user.user_type == 1) {
					return this.sb_count;
				} else if(this.$page.props.auth.user.user_type == 2) {
					return this.tc_count
				} else {
					return this.tp_count
				}
			},
			prospectContactsCount() {
				if(this.$page.props.auth.user.user_type == 1) {
					return this.prospect_sb;
				} else if(this.$page.props.auth.user.user_type == 2) {
					return this.prospect_tc
				} else {
					return this.prospect_tp
				}
			},
			activeContactsCount() {
				if(this.$page.props.auth.user.user_type == 1) {
					return this.active_sb;
				} else if(this.$page.props.auth.user.user_type == 2) {
					return this.active_tc
				} else {
					return this.active_tp
				}
			},
			userPermissions() {
				return this.$page.props.auth.user.user_permission;
			},
            userID() {
				return this.$page.props.auth.user.user_id;
			},
			userType() {
				return this.$page.props.auth.user.user_type;
			},
			userTypeAbbr() {
				return this.$page.props.auth.user.user_type_abbr;
			},
			remainPaymntDays() {
				return this.$page.props.auth.user.payment_days;
			},
			isPaymentNotSet() {
				return this.$page.props.auth.user.payment_not_setup;
			},
			oldConnectedAccountDetails() {
				return this.$page.props.auth.user.oldConnectedAccountDetails;
			},
			isUltraAdmin() {
				return this.$page.props.auth.user.is_ultra_admin;
			},
			gridBoxesData() {
				let datas = [
					{flag: true, dataCount: this.unread_events, viewURL: route(this.userTypeAbbr + '-all-event'), title: 'IRS Tax Tips', icon: '<i class="bx bx-calendar-check font-size-24"></i>'},
					{flag: !this.isUltraAdmin ? true : false, dataCount: this.currentMonthCalEvents, viewURL: route(this.userTypeAbbr + '-calendar'), title: 'Calendar Events', icon: '<i class="bx bx-calendar font-size-24"></i>'},
					{flag: true, dataCount: this.newNotifications, viewURL: route(this.userTypeAbbr + '-notification'), title: 'Notifications', icon: '<i class="bx bx-bell font-size-24"></i>'},
					{flag: true, dataCount: this.unread_news, viewURL: route(this.userTypeAbbr + '-all-news'), title: 'IRS News Releases', icon: '<i class="bx bx-news font-size-24"></i>'},
					{flag: true, dataCount: this.contactsCount, viewURL: route(this.userTypeAbbr + '-productivity', this.onlyContactsUrlEncrpt), title: 'Contacts', icon: '<i class="bx bxs-phone-call font-size-24"></i>'},
					{flag: true, dataCount: this.prospectContactsCount, viewURL: route(this.userTypeAbbr + '-productivity', this.prospectUrlEncrpt), title: 'Prospects', icon: '<i class="bx bxs-user-plus font-size-24"></i>'},
					{flag: true, dataCount: this.activeContactsCount, viewURL: route(this.userTypeAbbr + '-productivity', this.activeUrlEncrpt), title: 'Active Users', icon: '<i class="bx bxs-user font-size-24"></i>'},
					{flag: true, dataCount: this.all_locked_users.length, viewURL: route(this.userTypeAbbr + '-locked-accounts'), title: 'Locked Accounts', icon: '<i class="bx bxs-lock font-size-24"></i>'}
				]
				return datas;
			},
			buttons() {
				let name = {createbutton: '<i class="mdi mdi-plus me-1"></i> Create New', viewbutton: 'View All'}

				let data = [
					{istrue: true, createurl: !this.isUltraAdmin ? route(this.userTypeAbbr + '-all-event', '#create') : '', viewurl: route(this.userTypeAbbr + '-all-event')},
					{istrue: !this.userPermissions || this.userPermissions.invoices ? true : false, createurl: route(this.userTypeAbbr + '-invoice'), viewurl: route(this.userTypeAbbr + '-invoice')},
					{istrue: !this.userPermissions || this.userPermissions.task_management ? true : false, createurl: route(this.userTypeAbbr + '-task_create'), viewurl: route(this.userTypeAbbr + '-task_management_index')},
					{istrue: !this.userPermissions || this.userPermissions.email_blast ? true : false, createurl: route(this.userTypeAbbr + '-all-campaign-templates', this.encryptedUserId), viewurl: route(this.userTypeAbbr + '-campaign-list')}
				]

				for(let x in data){
					data[x] = {...name, ...data[x]}
				}
				return data;
			},
			tableData() {
				let data = [
					{id: 1, flag: this.userType == 1 ? true : false,  title: 'Quick Tips', classes: !this.isUltraAdmin ? 'col-xl-6' : 'col-xl-12', rows: this.irsTableRows, button: this.buttons[0], column: [
						{title: 'Title', width: ''},
						{title: 'Description', width: ''},
						{title: 'Created On', width: ''}
					]},
					{id: 2, flag: this.userType == 2 || this.userType == 3 ? true : false, title: 'Invoices', classes: 'col-xl-6', rows: this.invoiceTableRows, button: this.buttons[1], column: [
						{title: 'Date', width: ''},
						{title: 'Invoice ID', width: ''},
						{title: 'Creator', width: 'width:17%'},
						{title: 'Receiver', width: 'width:28%'},
						{title: 'Status', width: 'width:16%'}
					]},
					{id: 3, flag: !this.isUltraAdmin ? true : false, title: 'Tasks', classes: 'col-xl-6', rows: this.taskTableRows, button: this.buttons[2], column: [
						{title: 'Assigned By', width: 'width:33%'},
						{title: 'Title', width: ''},
						{title: 'Description', width: 'width:25%'},
						{title: 'Due Date', width: 'width:20%'}
					]},
					{id: 4, flag: !this.isUltraAdmin ? true : false, title: 'Email Campaigns', classes: 'col-xl-12', rows: this.campaignTableRows, button: this.buttons[3], column: [
						{title: 'Campaign Name', width: ''},
						{title: 'Template Name', width: ''},
						{title: 'Campaign Date', width: ''},
						{title: 'Status', width: ''}
					]}
				]
				return data;
			},
			irsTableRows() {
				let data = '';

				if(this.get_event.length > 0) {
					for(let x in this.get_event){
						data += `
								<tr>
                            		<td>
                            			<a href="${this.get_event[x].url}">
                                    		${this.$options.filters.descriptionsLength(this.get_event[x].title, 15)}
                                		</a>
                            		</td>
                            		<td>
                                		<a href="${this.get_event[x].url}">
											${this.$options.filters.descriptionsLength(this.get_event[x].description, 40)}
                                		</a>
                            		</td>
                            		<td> 
										${this.$options.filters.formatDate(this.get_event[x].created_on)}
									</td>
                        		</tr>
							`
					}
				} else {
					data = `
							<tr>
                        		<td colspan="3">
                                	<div class="text-center">
                                    	<span>No Quick Tips Available.</span>
                                	</div>
                            	</td>
                        	</tr>
						`
				}
				return data;
				
			},
			invoiceTableRows() {
				let data = '';

				if(this.get_all_own_generated_invoice && this.get_all_own_generated_invoice.length > 0) {
					for(let x in this.get_all_own_generated_invoice){
						data += `
								<tr>
									<td>
										${this.$options.filters.formatDate(this.get_all_own_generated_invoice[x].created_at)}
									</td>
									<td>
										<a href="${this.get_all_own_generated_invoice[x].pay_invoice_url}" title="View Invoice" target="_blank">
											${this.get_all_own_generated_invoice[x].invoice_id} <i class="fas fa-file-pdf" aria-hidden="true"></i>
										</a>
									</td>
									<td>
										${this.$options.filters.userNameEmail(this.userID, this.get_all_own_generated_invoice[x].sender_id, this.get_all_own_generated_invoice[x].sender_name, this.get_all_own_generated_invoice[x].sender_email, 18, 18, this.get_all_own_generated_invoice[x].self_user_url)}
									</td>
									<td>
										${this.$options.filters.userNameEmail(this.userID, this.get_all_own_generated_invoice[x].receiver_id, this.get_all_own_generated_invoice[x].receiver_name, this.get_all_own_generated_invoice[x].receiver_email, 10, 10, this.get_all_own_generated_invoice[x].receiver_url)}
									</td>
									<td>
										${this.get_all_own_generated_invoice[x].invoice_pay_status}
									</td>                                
								</tr>		
							`
					}
				} else {
					data = `
							<tr>
                        		<td colspan="5">
                                	<div class="text-center">
                                    	<span>No Invoices Available.</span>
                                	</div>
                            	</td>
                        	</tr>
						`
				}
				return data;
			},
			taskTableRows() {
				let data = '';

				if(this.tasks.length > 0){
					for(let x in this.tasks){
						data += `
								<tr>
                                	<td>
                                    	<a href="${this.tasks[x].assigner_profile_link}">
                                        	${this.tasks[x].assigned_by_name}
                                    	</a>
                                	</td>
                                	<td>
                                    	<a href="${this.tasks[x].view_link}">
                                        	${this.$options.filters.descriptionsLength(this.tasks[x].title,10)}
                                    	</a>
                                	</td>
                                	<td>
                                    	<a href="${this.tasks[x].view_link}">
                                         	${this.$options.filters.descriptionsLength(this.tasks[x].description, 10) == null? '' : this.$options.filters.descriptionsLength(this.tasks[x].description,10)}
                                    	</a>
                                	</td>
                                	<td> 
										${this.$options.filters.formatDate(this.tasks[x].due_on)}
									</td>
                            	</tr>
							`
					}
				}
				else {
					data = `
							<tr>
                                <td colspan="4">
                                    <div class="text-center">
                                        <span>No Tasks Available.</span>
                                    </div>
                                </td>
                            </tr>
						`
				}
				return data;
			},
			campaignTableRows() {
				let data = '';

				if(this.all_campaigns.length > 0){
					for(let x in this.all_campaigns){
						let status = '';
								if(!this.all_campaigns[x].is_trash){
									if(this.all_campaigns[x].sending_status == 1)
                                    	status += `<span class="paid-greenz text-decoration-none">Sent</span>`
									else if(this.all_campaigns[x].sending_status == 2)
                                    	status += `<span class="text-primary text-decoration-none">Draft</span>`
									else if(this.all_campaigns[x].sending_status == 0 && this.all_campaigns[x].original_campaign_date < this.all_campaigns[x].current_date)
                                    	status += `<span class="text-info text-decoration-none">Sending</span>`
									else if(this.all_campaigns[x].sending_status == 0)
                                    	status += `<span class="text-warning text-decoration-none">Pending</span>`
									else if(this.all_campaigns[x].sending_status == 4)
                                    	status += `<span class="text-danger text-decoration-none">Paused</span>`								
								}
								else{
                                	status += `<span class="text-danger text-decoration-none">Deleted</span>`
								}
						data += `
								<tr>
                                	<td>
                                    	<a href="${this.all_campaigns[x].url}">
                                         	${this.$options.filters.descriptionsLength(this.all_campaigns[x].title,40)}
                                     	</a>
                                	</td>
                                	<td>
                                    	<a href="${this.all_campaigns[x].url}">
                                         	${this.$options.filters.descriptionsLength(this.all_campaigns[x].template_name,20)} 
                                    	</a>
                                	</td>
                                	<td>
										${this.all_campaigns[x].campaign_date}
									</td>
									<td>
										${status}
									</td>
								</tr>
							`
								
						
					}
				}
				else{
					data = `
							<tr>
                                <td colspan="4">
                                    <div class="text-center">
                                        <span>No Email Campaigns Available.</span>
                                    </div>
                                </td>
                            </tr>
						`
				}
				return data;
			}
		}
  	};
</script>

<template>
  	<Layout>
		<Head :title="title" />
		<!-- start page title -->
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0 font-size-18">Dashboard</h4>
				</div>
			</div>
		</div>
		<div v-if="!isNeedResubscribe && (remainPaymntDays || isPaymentNotSet)" class="alert alert-danger" role="alert">
			<a :href="route(userTypeAbbr + '-billing', ['#subscription'])" class="alert-link">
				<h4 class="alert-heading"><i class="fab fa-cc-stripe"></i> &nbsp;&nbsp;Payment Setup!</h4>
				<p v-if="remainPaymntDays && !isPaymentNotSet">
					Your free trial period ends on {{this.$page.props.auth.user.renew_payment_date | formatDate}}. Please setup your payment details by clicking this area to continue using the site.
				</p>
				<p v-if="isPaymentNotSet">
					Your 30 day trial has come to an end. You can regain full access of your account by clicking this area to update your payment information.
				</p>
			</a>
		</div>
		<div v-if="isNeedResubscribe" class="alert alert-info" role="alert">
			<a :href="route(this.userTypeAbbr + '-resubscribe')" class="alert-link">
				<h4 class="alert-heading">
					<i class="fab fa-cc-stripe"></i> &nbsp;&nbsp;Update Billing Information!
				</h4>
				<p>
					In order to enjoying the features we need you to update your billing details.
					This will NOT charge anything extra to your card.
				</p>
			</a>
			<a :href="route(this.userTypeAbbr + '-resubscribe')" class="btn btn-success waves-effect waves-light mb-2 me-2">Click to Update</a>
		</div>
		<div v-if="oldConnectedAccountDetails" class="alert alert-danger" role="alert">
			<a :href="route(userTypeAbbr + '-billing', ['#bank'])" class="alert-link">
				<h4 class="alert-heading"><i class="fab fa-cc-stripe"></i> &nbsp;&nbsp;Reconnect your account!</h4>
				<p>
					Reconnect your account to continue receiving payment from other parties.
				</p>
			</a>
			<a :href="route(userTypeAbbr + '-billing', ['#bank'])" class="btn btn-success waves-effect waves-light mb-2 me-2">Click to Reconnect</a>
		</div>
		<div class="row">
			<div class="col-xl-12">
				<div class="row">
					<template v-for="(item, index) in gridBoxesData">
						<GridBox 
							v-if="item.flag"
							:key="index"
							:dataCount="item.dataCount"
							:viewURL="item.viewURL"
							:title="item.title"
							:icon="item.icon"
						/>
					</template>
				</div>
			</div>
		</div>
		<div class="row">
			<template v-for="(item, index) in tableData">
				<GridTable v-if="item.flag"
					:key="index"
					:classes="item.classes"
					:title="item.title"
					:columns="item.column"
					:buttons="item.button"
					:rows="item.rows"	
				/>
			</template>
		</div>
  	</Layout>
</template>
